import type { Questionnaire } from '@medplum/fhirtypes'

export const editTaskOwnerQuestionnaire = {
  resourceType: 'Questionnaire',
  status: 'active',
  url: 'https://www.seenhealth.org/fhir/Questionnaire/task-assign-owner',
  id: 'task-assign-owner',
  title: 'Assign Owner to the Task',
  item: [
    {
      linkId: 'owner',
      text: 'Owner',
      type: 'reference',
      extension: [
        {
          url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-referenceResource',
          valueCodeableConcept: {
            coding: [
              {
                system: 'http://hl7.org/fhir/fhir-types',
                display: 'Practitioner',
                code: 'Practitioner',
              },
            ],
          },
        },
      ],
      required: true,
    },
  ] as const,
} satisfies Questionnaire
